import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type { KinerjaKsStatus } from 'types/kinerja-ks'
import type { FC } from 'react'

export interface SchoolItemBadgeProps {
  status: KinerjaKsStatus
}

const options: Array<{
  status: KinerjaKsStatus
  label: string
  variant: BadgeProps['variant']
}> = [
  {
    status: 'NOT_FOUND',
    label: 'Belum dimulai',
    variant: 'neutral',
  },
  { status: 'DRAFT', label: 'Perencanaan', variant: 'neutral' },
  {
    status: 'READY',
    label: 'Pelaksanaan dan Penilaian',
    variant: 'critical',
  },
]

const SchoolItemBadge: FC<SchoolItemBadgeProps> = ({ status }) => {
  const option = options.find((option) => option.status === status)

  return <Badge variant={option?.variant || 'neutral'}>{option?.label}</Badge>
}

export default SchoolItemBadge
